import axios from 'axios'
import { getAppConfigSetting } from '../utils'
import { COUNTRIES_API } from './constants'

const countriesUrl = () => `${getAppConfigSetting('apiUrl')}${COUNTRIES_API}?restricted=true`

export const getCountries = () => axios.get(countriesUrl(), { withCredentials: true })
